import React from 'react'
import { Collapse, Button } from 'antd';

const { Panel } = Collapse;

export default function ViewFqa() {
    
    const text = `A dog is a type of domesticated animal.Known for its loyalty and faithfulness,it can be found as a welcome guest in many households across the world.`;

    return (
        <div id="fqa" className="block faqBlock">
            <div className="container-fluid">
                <div className="titleHolder">
                    <h2>您將了解以下問題</h2>
                    <span>建立證照地圖，詳細陳列證照與課程學習關聯圖，能有效引導學生學習方向</span>
                </div>
                <Collapse defaultActiveKey={['1']}>
                    <Panel header="This is panel header 1" key="1">
                        <p>{text}</p>
                    </Panel>
                    <Panel header="This is panel header 2" key="2">
                        <p>{text}</p>
                    </Panel>
                    <Panel header="This is panel header 3" key="3">
                        <p>{text}</p>
                    </Panel>
                </Collapse>
                <div className="quickSupport">
                    <h3>歡迎來信</h3>
                    <p>建立證照地圖，詳細陳列證照與課程學習關聯圖，能有效引導學生學習方向</p>
                    <Button type="primary"><i className="fas fa-envelope"></i> Email</Button>
                </div>
            </div>
        </div>
    )
}
